import { Modal } from '@/components/Modal'

import { modalId } from '../hooks/useController'
import { Content } from './Content'
type Props = {
  recurrentOrderId: string | null
  date: string | null
  type: uui.domain.client.rm.OrderStepIdentifier
}

export function Root(props: Props) {
  const { recurrentOrderId, date, type } = props

  if (!recurrentOrderId || !date) return null

  return (
    <Modal modalId={modalId}>
      <Content recurrentOrderId={recurrentOrderId} date={date} type={type} />
    </Modal>
  )
}
